import './Prices.css';
import React from "react";
import { useNavigate } from "react-router-dom";
import p1 from "./images/party-parlour-photo2.jpg";
import p2 from "./images/party-parlour-photo3.jpg";
import p3 from "./images/party-parlour-photo4.png";

const packages = [
  {
    name: "Essential",
    price: "$299",
    duration: "2 hours",
    image: p1
  },
  {
    name: "Deluxe",
    price: "$499",
    duration: "4 hours",
    image: p2,
    popular: true
  },
  {
    name: "Premium",
    price: "$699",
    duration: "6 hours",
    image: p3
  }
];

const Prices = () => {
  const navigate = useNavigate();

  return (
    <div className="prices-page">
      {/* Header Section */}
      <section className="prices-header">
        <div className="prices-header-content">
          <h1>Our Photo Booth Packages</h1>
          <p className="subtitle">Choose the perfect package for your event</p>
          <p className="description">
            All packages include professional setup, high-quality equipment, and our signature service. 
            Custom packages available upon request.
          </p>
        </div>
      </section>

      {/* Packages Section */}
      <section className="packages-section">
        <div className="packages-container">
          {packages.map((pkg, index) => (
            <div key={index} className={`package-card ${pkg.popular ? 'popular' : ''}`}>
              {pkg.popular && (
                <div className="popular-badge">Most Popular</div>
              )}
              
              <div className="package-image-frame">
                <div className="package-frame">
                  <img src={pkg.image} alt={pkg.name} className="package-image" />
                </div>
              </div>

              <div className="package-content">
                <div className="package-header">
                  <h2>{pkg.name}</h2>
                  <div className="package-duration">{pkg.duration}</div>
                </div>
                
                <div className="package-price">
                  <span className="price-amount">{pkg.price}</span>
                </div>

                <button
                  className="package-button"
                  onClick={() => navigate("/Contact")}
                >
                  Book Now
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Parlour Perks Section */}
      <section className="parlour-perks-section">
        <div className="parlour-perks-content">
          <div className="perks-header">
            <h2>Parlour Perks</h2>
            <p className="perks-subtitle">Enhance your experience with these add-ons</p>
          </div>
          <div className="perks-grid">
            <div className="perk-item">
              <div className="perk-icon">🎭</div>
              <h3>Props</h3>
              <p className="perk-price">$5 each</p>
              <p className="perk-description">Add fun props to your photo booth experience</p>
            </div>
            <div className="perk-item">
              <div className="perk-icon">🎨</div>
              <h3>Personalized Backdrops</h3>
              <p className="perk-price">Starting at $149</p>
              <p className="perk-description">Custom backdrops tailored to your event theme</p>
            </div>
            <div className="perk-item">
              <div className="perk-icon">🖨️</div>
              <h3>Printing</h3>
              <p className="perk-price">$149</p>
              <p className="perk-description">High-quality instant prints your guests can take home as lasting memories</p>
            </div>
            <div className="perk-item">
              <div className="perk-icon">⏰</div>
              <h3>Additional Hours</h3>
              <p className="perk-price">$99</p>
              <p className="perk-description">Extend your photo booth rental time</p>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Info Section */}
      <section className="prices-info">
        <div className="prices-info-content">
          <h2>Product Features</h2>
          <div className="info-grid">
            <div className="info-item">
  <div className="info-icon">📸</div>
  <h3>Digital Photos</h3>
  <p>High-resolution images delivered instantly to capture every moment.</p>
</div>

<div className="info-item">
  <div className="info-icon">🎨</div>
  <h3>Custom Photo Templates</h3>
  <p>Personalized photo designs tailored to match your event theme.</p>
</div>

<div className="info-item">
  <div className="info-icon">🌐</div>
  <h3>Online Gallery Access</h3>
  <p>Easy access to a private online gallery to view and download your photos.</p>
</div>

<div className="info-item">
  <div className="info-icon">👥</div>
  <h3>On-Site Attendants</h3>
  <p>Friendly professionals on location to assist guests and ensure everything runs smoothly.</p>
</div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="prices-cta">
        <div className="prices-cta-content">
          <h2>Need a Custom Package?</h2>
          <p>We'd love to create a tailored experience for your special event</p>
          <button className="btn-primary large" onClick={() => navigate("/Contact")}>
            Contact Us for Custom Quote
          </button>
        </div>
      </section>
    </div>
  );
};

export default Prices;

